<template>
  <div class="campaign-container">
    <Loading v-if="!loadStatus" text="Loading..." />
    <template v-if="loadStatus">
      <section v-if="isNotFound">
        <Error />
      </section>

      <section v-else>
        <div class="campaign-card" :class="{ disabled: disabled }">
          <div>
            <div class="campaign-card-header">
              <h4 class="campaign-title">{{ projectTitle }}</h4>
              <p
                class="campaign-subtitle inter"
                v-if="projectInfo.enableCustomSubheading"
              >
                {{
                  projectInfo.adminOrderSubheading ||
                  `Complete form to receive a gift from ${projectInfo.teamName}.`
                }}
              </p>
              <p class="campaign-subtitle inter" v-else>
                Complete form to receive a gift from {{ projectInfo.teamName }}.
              </p>
            </div>

            <div class="campaign-card-body">
              <div class="campaing-card-indicators">
                <div class="campaing-card-indicators-item active"></div>
                <div class="campaing-card-indicators-item"></div>
              </div>
              <p class="campaign-subtitle inter">
                {{ getHeader(uuid) }}
              </p>
              <div class="link-grid">
                <a
                  v-for="(link, index) in projectInfo.orderAttachmentRecords"
                  :key="index"
                  :href="link.url"
                  target="_blank"
                  >{{ link.name }}</a
                >
              </div>

              <!-- Gift Selection here -->
              <div
                v-for="(projects, index) in projectInfo.products"
                :key="index"
              >
                <ProjectTierSelection
                  :projects="projects"
                  ref="selectedProducts"
                  @update-selected-items="updateSelectedItems(index, $event)"
                  @update-is-tiers-valid="updateIsTiersValid(index, $event)"
                  @showError="showError"
                  :totalTiersCount="projectInfo.customApparelSizeOptions.length"
                />
              </div>

              <div class="button-region flex">
                <button
                  :class="{ 'button-gemnote--disabled': !isTiersValid }"
                  :disabled="!isTiersValid"
                  class="button-gemnote button-gemnote--small"
                  @click="handleSelecteion"
                >
                  <span>next</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import { progressStatus, layouts } from '@/helpers'
import VTooltip from 'v-tooltip'
import Error from '../Universal/Error.vue'
import ProjectTierSelection from './ProjectTierSelection.vue'

Vue.use(VTooltip)

export default {
  name: 'ProjectItemsSelection',
  props: ['uuid'],
  components: { Error, ProjectTierSelection },

  data() {
    return {
      innerWidth: window.innerWidth,
      selectedItems: [],
      showValidationError: false,
      showOptionsError: false,
      errorMessage: '',
      selectedTier: [],
      tiersValid: [],
      isTiersValid: true,
      pageLoaded: false,
    }
  },

  computed: {
    loadStatus() {
      return progressStatus(this.loadingProjectLinkInfo)
    },
    disabled() {
      return Object.keys(this.projectInfo).length > 0 ? false : true
    },

    isNotFound() {
      return (
        this.projectInfo.orderFinalized ||
        !this.projectInfo.enableCollectionLink
      )
    },

    projectTitle() {
      return (
        (this.projectInfo &&
          this.projectInfo.enableCustomTitle &&
          this.projectInfo.adminOrderTitle) ||
        "Hurray! You're getting a gift."
      )
    },
    isDisabled() {
      const isEmpty = this.selectedItems.some((item) => {
        return Object.values(item.option).some((option) => {
          return !option.length
        })
      })
      return isEmpty || !this.selectedItems.length
    },

    allowedItems() {
      const { products, numberOfAdminOrderProductSelections } = this.projectInfo
      const productLength = products && products.length
      const adminOrderSelection = numberOfAdminOrderProductSelections || 1

      const isAdminOrderGreater = adminOrderSelection > productLength
      const allowed = isAdminOrderGreater ? productLength : adminOrderSelection

      return allowed
    },

    displayMessage() {
      return `Tier 1 Choose upto ${this.allowedItems} ${
        this.allowedItems == 1 ? 'item' : 'items'
      }`
    },

    ...mapState({
      loadingProjectLinkInfo: (state) => state.project.loadingProjectLinkInfo,
      projectInfo: (state) => state.project.projectInfo,
      recipientInfo: (state) => state.project.recipientInfo,
      settingProjectRecipientInfo: (state) =>
        state.project.settingProjectRecipientInfo,
      emailInUse: (state) => state.project.emailInUse,
    }),
  },
  watch: {
    tiersValid: {
      handler() {
        if (this.pageLoaded) {
          this.checkIfValid(false)
        }
      },
      deep: true, // This ensures that nested properties of tiersValid are also observed
    },
  },
  async created() {
    await this.$store.dispatch(
      'layout/setPageLayout',
      layouts.ADDRESS_COLLECTION
    )

    await this.$store.dispatch('project/getProjectLinkInfo', {
      projectId: this.uuid,
      redirect: false,
    })
    this.pageLoaded = true
  },

  mounted() {
    this.handlePersistedItems()
    window.addEventListener('resize', () => {
      this.innerWidth = window.innerWidth
    })
  },

  methods: {
    getHeader(uuid) {
      // This UUID represents the Whatnot store. If it matches, show "Pick your items", otherwise "Pick your gifts".
      return uuid === 'd6a1839d-4d71-42c7-95ea-6f4cf1d85754'
        ? 'Pick your items'
        : 'Pick your gifts'
    },
    updateSelectedItems(index, items) {
      Vue.set(this.selectedItems, index, items)
      localStorage.setItem(
        'adminOrderSelectedItems',
        JSON.stringify(this.selectedItems.flatMap((item) => item))
      )
    },

    updateIsTiersValid(index, validation) {
      Vue.set(this.tiersValid, index, validation)
    },
    updateSelection(id, option, value) {
      const product = this.selectedItems.find((item) => item.id == id)
      const foundOption = Object.keys(option)[0]

      if (product && foundOption) {
        product.option[foundOption] = value
      }
    },

    handlePersistedItems() {
      const persistedItems = localStorage.getItem('adminOrderSelectedItems')
      if (persistedItems && persistedItems.length) {
        this.selectedItems = JSON.parse(persistedItems)
      }
    },
    handleSelecteion() {
      this.checkIfValid(true)
      let selectedItems = []
      const mergeTiers = [].concat(...this.$refs.selectedProducts)
      const products = mergeTiers.map((product) => {
        return product.getSelectedItems
      })
      products.forEach((product) => {
        product.forEach((item) => {
          this.selectedItems.push(item)
          selectedItems.push(item)
        })
      })
      this.removeAlreadySelected(selectedItems)
    },
    removeAlreadySelected(selectedItems) {
      const products = this.removeDuplicates(selectedItems, 'id')
      if (!products.length) {
        this.showError(true, `Please select at least one item.`)
        this.isTiersValid = false
      }
      if (!this.showOptionsError) {
        localStorage.setItem(
          'adminOrderSelectedItems',
          JSON.stringify(products)
        )
        this.$router.push({ name: 'AddressCollectionRecipient' })
      }
    },
    removeDuplicates(arr) {
      const uniqueIds = []
      const unique = arr.filter((element) => {
        const isDuplicate = uniqueIds.includes(element.id)

        if (!isDuplicate) {
          uniqueIds.push(element.id)

          return true
        }

        return false
      })
      return unique
    },
    checkIfValid(showTierErrors = true) {
      const tiers = this.tiersValid.filter((tier) => {
        return tier.isValid === false
      })
      const lastElement = tiers[tiers.length - 1]
      let errorMessage = ''
      const mergeTiers = [].concat(...this.$refs.selectedProducts)

      mergeTiers.forEach((tierComponent) => {
        tierComponent.tiersValidation(showTierErrors)
      })
      if (tiers.length !== 0) {
        tiers.forEach((item) => {
          if (item.tier.name !== lastElement.tier.name) {
            errorMessage += item.tier.name + ', '
          } else {
            errorMessage += item.tier.name
          }
        })
        if (tiers.length === 1) {
          this.showError(true, `${errorMessage} is incomplete.`)
          this.isTiersValid = false
        } else {
          this.showError(true, `${errorMessage} are incomplete.`)
          this.isTiersValid = false
        }
      } else {
        this.showError(false, ``)
        this.isTiersValid = true
      }
    },
    showError(show, message) {
      this.showOptionsError = show
      this.errorMessage = message
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.gift-region {
  margin-top: 4rem;

  .message {
    text-align: left;
    font-weight: bold;
    margin-top: 1.25rem;
  }

  .border-divider {
    margin-top: 1rem;
    border-bottom: 6px solid $main-5;
  }

  .gift-selections {
    margin: 3rem 0;
    display: flex;
    gap: 2rem;
    justify-content: left;
    flex-wrap: wrap;

    &.wrapped {
      justify-content: start;
    }

    .gift-holder {
      margin-bottom: 5rem;
    }
  }
}

.attachments {
  margin-top: 1.25rem;
  gap: 1rem;

  a {
    font-size: 12px;
  }
}

.disabled {
  opacity: 0.9;
  pointer-events: none;
}

.campaign-container {
  height: auto;
  margin: 0 auto;
}

.campaign-card {
  min-width: 100%;
  margin: 0 auto;
  padding: 2rem 0rem;
  padding-bottom: 8rem;
}

.campaign-card-body {
  margin: 1.5rem 0;
  border: 1px solid $main-5;
  border-radius: 1rem;
  padding: 2rem 0;

  .campaign-subtitle {
    font-weight: 700;
    font-size: 1.563rem;

    @media (max-width: 575.98px) {
      font-size: 1.125rem;
    }
  }

  .campaing-card-indicators {
    display: flex;
    gap: 1rem;
    align-items: center;
    justify-content: center;
    margin-bottom: 2rem;

    .campaing-card-indicators-item {
      width: 44px;
      height: 5px;
      border-radius: 100px;
      background-color: $main-1;
      cursor: pointer;

      &.active {
        background-color: $main-5;
      }
    }
  }
}

.campaign-card-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.5rem;

  @media (max-width: 575.98px) {
    justify-content: center;
    flex-direction: column;
    width: 100%;
    gap: 1rem;
  }

  .campaign-subtitle {
    font-size: 0.938rem;
    text-align: left;
  }
}

.campaign-title {
  font-family: 'Editorial New';
  font-size: 2.5rem;
  font-weight: normal;
  text-align: left;
}

.campaign-subtitle {
  font-size: 1rem;
  text-align: center;
}

.button-region {
  margin: 3rem 0 1rem 0;
  justify-content: center;
  display: flex;
  align-items: center;
  gap: 2rem;

  .button-holder {
    display: flex;
    align-items: center;

    p {
      color: #ce3c3c;
      font-size: 0.625rem;
      margin-right: 0.5rem;
      font-weight: 700;
    }
  }

  @media (max-width: 575.98px) {
    justify-content: center;
    width: 100%;
  }

  @media (min-width: 576px) and (max-width: 767.98px) {
    justify-content: center;
    width: 100%;
  }

  p {
    font-size: 0.875rem;
    color: #232220;

    span {
      color: #a09c95;
    }
  }

  .button-gemnote {
    height: 2.5rem;
    width: auto;
    padding: 0 2rem !important;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
}

@media (max-width: 575.98px) {
  .gift-holder {
    width: 100% !important;
    flex-basis: 80%;
  }

  .wrapped {
    justify-content: center !important;
  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  .gift-holder {
    width: 100% !important;
    flex-basis: 80%;
  }

  .wrapped {
    justify-content: center !important;
  }
}

@media screen and (max-width: 1000px) and (min-width: 800px) {
  .campaign-container {
    transition: 1s ease-in;
  }

  .campaign-card {
    width: 100%;
  }
}

@media screen and (max-width: 799px) and (min-width: 700px) {
  .campaign-container {
    transition: 1s ease-in;
    padding-bottom: 4rem;
  }

  .campaign-card {
    width: 100%;
    padding: 4rem 0;
  }

  .campaign-info-links {
    gap: 1.5rem;
  }
}

@media screen and (max-width: 699px) and (min-width: 500px) {
  .campaign-container {
    transition: 1s ease-in;
    padding-bottom: 3rem;
  }

  .campaign-card {
    width: 100%;
    padding: 3rem 0;
  }

  .campaign-title {
    font-size: 2rem;
  }

  .campaign-subtitle {
    font-size: 14px;
  }

  form {
    width: 75%;
    margin: 2rem auto auto auto;
  }

  .inline-inputs {
    flex-wrap: wrap;
    gap: 2rem;
  }

  .inline-inputs > * {
    flex: 0 1 100%;
  }

  .campaign-info-links {
    gap: 1rem;
  }
}

@media screen and (max-width: 499px) and (min-width: 320px) {
  .campaign-container {
    transition: 1s ease-in;
    padding-bottom: 2rem;
  }

  .campaign-card {
    width: 100%;
    padding: 1rem 0;
  }

  .campaign-title {
    font-size: 2rem;
  }

  .campaign-subtitle {
    font-size: 11px;
  }
}

.link-grid {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 5px;
  margin-bottom: 2rem;

  a {
    font-size: 0.75rem;
  }
}

.card-header {
  display: flex;
  justify-content: space-between;
}

.selected-card-counter {
  margin-top: 1.25rem;
}
</style>
